import { render, staticRenderFns } from "./subsidyList.vue?vue&type=template&id=4d74727b&"
import script from "./subsidyList.vue?vue&type=script&lang=js&"
export * from "./subsidyList.vue?vue&type=script&lang=js&"
import style0 from "./subsidyList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports